import { withTranslation } from '@application/i18n/with_translation';
import { Bleed, Box, Divider, Flex, Stack, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { AppointmentCaseModel, AppointmentData, MetaData } from '@feature/cases/case_appointment_model';
import { FormCard } from '@feature/dynamic_form/form_card.component';
import type { AttemptData } from '@feature/payment/payment.controller';
import { PaymentCard } from '@feature/payment/payment_card.component';
import { FormOpportunity } from '@visiba/api-vcs-client-v2';

// TODO: Needs other data structures
type MergedData = AppointmentData & MetaData;

interface Props {
	data: MergedData | null;
	model: AppointmentCaseModel;
}

export function InfoViewAppointmentUnhandledActions({ data, model }: Props): JSX.Element | null {
	const isUnpaid = data?.payment?.State === 'Unpaid';
	const forms =
		data?.forms
			.filterForms({
				completed: false,
				opportunity: !data.completed ? FormOpportunity.BeforeBooking : [FormOpportunity.BeforeBooking, FormOpportunity.AfterBooking],
			})
			.map((formWorker) => <FormCard analyticAction='Clicked to answer form' key={formWorker.formId} formWorker={formWorker} />) ?? [];

	const paymentIsFinished = !isUnpaid;
	const formsAreFinished = forms.length === 0;

	function handlePaymentSuccess(data: AttemptData): void {
		model.markAsPayed(data);
	}

	if (paymentIsFinished && formsAreFinished) {
		return <Divider offset={tokens.size.x1_5} decorative />;
	}

	return (
		<Bleed bleedAmount='32px' asChild>
			<Box background={tokens.color.bg.surfaceBrand} horizontalPadding={tokens.spacing.x4} verticalPadding={tokens.spacing.x3}>
				<Stack gap={tokens.spacing.x2}>
					<Text variant='labelLargeSemiBold'>{withTranslation('PW.Component.Visits.BeforeAppointment.Title')}</Text>

					<Stack asChild gap={tokens.spacing.x2}>
						<Flex
							fluid
							breakpointMediumAndUp={{
								direction: 'row',
							}}
						>
							{isUnpaid ? (
								<Flex
									grow={1}
									basis='50%'
									shrink={0}
									justify='flex-start'
									asChild
									breakpointSmallAndUp={{
										align: 'flex-start',
									}}
								>
									<Stack gap={tokens.spacing.x1}>
										<Text variant='labelSemiBold'>
											{withTranslation('PW.Component.Visits.BeforeAppointment.Payment', {
												value: data.price?.Formatted ?? '',
											})}
										</Text>

										<PaymentCard
											analyticAction='Clicked: Pay for appointment'
											paymentAmount={data.price?.Formatted ?? ''}
											billId={data.payment.BillId}
											issueTrackingId={AppointmentCaseModel.APPOINTMENT_UNHANDLED_ISSUES_TRACKING_ID_PREFIX + data.ticket}
											onSuccess={handlePaymentSuccess}
										/>
									</Stack>
								</Flex>
							) : null}

							{forms.length > 0 ? (
								<Flex grow={1} basis='50%' shrink={0} asChild>
									<Stack gap={tokens.spacing.x1}>
										<Text variant='labelSemiBold'>{withTranslation('PW.Component.Visits.AppointmentInfo.UnsubmittedForms')}:</Text>
										{forms}
									</Stack>
								</Flex>
							) : null}
						</Flex>
					</Stack>
				</Stack>
			</Box>
		</Bleed>
	);
}
